// @flow

export const Widths = {
  FILTER_BOX: '18.8rem',
  FILTER_BAR_WIDTH: '22rem',
  SIDE_NAV_WIDTH: '5.5rem',
  REPORTS_PANEL_WIDTH: '25rem',
  DETAILS_WIDTH: '39.6rem',
  SETTINGS_NAV_BAR: '124px',
  CARD_WIDTH: '40rem',
};
export const Heights = {
  APP_HEADER: '70px',
  MENU_BAR: '240px',
};


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/themes/common/layouts.js